import React from 'react'
import { reduxForm } from 'redux-form'
import MoneyInput from 'components/money-input'
import Dropdown from 'components/dropdown'
import PropTypes from 'prop-types'
import Footer from 'multi-vertical/rate-table/components/filter-modal/footer'
import styles from './styles.scss'

/* eslint-disable indent */
const FilterForm = ({
  closeModal,
  update,
  reset,
  invalid,
  withFooter,
  onAmountChange,
  onCreditChange,
  customValidation,
  className,
}) => {
  const cancel = () => {
    closeModal()
    // Setting timeout so the form doesn't reset as the modal is disappearing
    setTimeout(() => { reset() }, 500)
  }

  return (
    <div className={className}>
      <form className={`${styles.filters} pure-g`} method="POST" onSubmit={e => { e.preventDefault() }}>
        <div className="pure-u-1 pure-u-md-1-2 pure-u-sm-11-24">
          <div className="mr-md-8 mb-16 mb-sm-8 mb-md-0">
            <MoneyInput
              name="loanAmount"
              label="Loan Amount"
              onChange={onAmountChange}
              exposeValue
              placeholder="Loan amount"
              validate={customValidation}
              icon={false}
            />
          </div>
        </div>
        <div className="pure-u-1 pure-u-md-1-2 pure-u-sm-11-24">
          <div className={`${styles.creditScore} ml-sm-8 mb-24 mb-sm-8 mb-md-0`}>
            <Dropdown
              name="creditScoreApprox"
              label="Estimated Credit Score"
              onChange={onCreditChange}
              placeholder="Estimated credit score"
              options={[
                { value: '850', label: 'Excellent (750+)' },
                { value: '749', label: 'Good (700-749)' },
                { value: '699', label: 'Fair (640-699)' },
                { value: '639', label: 'Poor (<640)' },
              ]}
              icon={false}
            />
          </div>
        </div>
      </form>
      {withFooter && <Footer cancel={cancel} invalid={invalid} update={update} />}
    </div>
  )
},

noop = () => { }

FilterForm.propTypes = {
  closeModal: PropTypes.func,
  update: PropTypes.func,
  reset: PropTypes.func,
  invalid: PropTypes.bool,
  withFooter: PropTypes.bool,
  onAmountChange: PropTypes.func,
  onCreditChange: PropTypes.func,
  customValidation: PropTypes.array,
  className: PropTypes.string,
}

FilterForm.defaultProps = {
  closeModal: noop,
  update: noop,
  reset: noop,
  onCreditChange: noop,
  onAmountChange: noop,
  withFooter: false,
  customValidation: [],
  className: '',
}

export { FilterForm as FilterFormNoHoc }

export default reduxForm({
  keepDirtyOnReinitialize: false,
  enableReinitialize: true,
})(FilterForm)
